import { makeStyles } from '@mui/styles';

const loginStyles = makeStyles(theme => ({
	logoWrapper: {
		textAlign: 'center',
		marginTop: '30px',
		marginBottom: '60px !important',
	},
	logoImage: {
		maxWidth: '70%',
	},
	loginPaper: {
		textAlign: 'center',
		padding: '40px',
	},
	loginHeader: {
		fontSize: '30px !important',
		fontWeight: '400 !important',
		// [theme.breakpoints.down('sm')]: {
		// 	fontSize: '20px !important',
		// }
		marginBottom: '60px !important',
	},
	logoHeader: {
		flexGrow: 1,
		maxWidth: '70%',
	},
	textField: {
		width: '100%',
		// height: '38px',
		marginTop: '20px !important',
		backgroundColor: '#FAFAFB',
	},
	buttenPanel: {
		textAlign: 'center',
	},
	loginButton: {
		width: '80%',
		height: '38px',
		backgroundColor: '#93FF50 !important',
		color: '#000 !important',
		textTransform: 'uppercase',
		marginTop: '20px !important',
		marginLeft: '10% !important',
		marginRight: '10% !important',
	},
	backButton: {
		width: '80%',
		height: '38px',
		backgroundColor: '#fff !important',
		color: '#000 !important',
		textTransform: 'uppercase',
		marginTop: '20px !important',
		marginLeft: '10% !important',
		marginRight: '10% !important',
	},

	linksWrapper: {
		marginTop: '30px',
	},
	bottomWrapper: {
		marginTop: '20px',
		textAlign: 'center',
		paddingLeft: '30px',
		paddingRight: '30px',
	},
	copyrightText: {
		color: '#000',
	},
	bottomText: {
		color: '#000',
	},
	bottomText2: {
		color: '#000',
		paddingTop: '40px',
	},
	bottomStickyWrapper: {
		width: '100%',
		height: '40px',
		paddingLeft: '40px',
		paddingRight: '40px',
	},
	forgotPasswordLinkWrapper: {
		textAlign: 'right',
		paddingBottom: '40px',
	},
	forgotPasswordLink: {
		fontSize: '0.7rem !important',
		textDecoration: 'none  !important',
	},

}));

export default loginStyles;